<div class="login-container">
  <div class="login-card bg-white p-8 rounded-lg shadow-lg">
    <!-- Header -->
    <div class="login-header text-center mb-6">
      <div class="logo flex items-center justify-center mb-2">
        <app-icon
          name="inventory"
          color="primary"
          [size]="32"
          class="mr-2"
        ></app-icon>
        <h1 class="text-2xl font-bold text-gray-900">Estokai</h1>
      </div>
      <p class="subtitle text-gray-600">Sistema de Gestão de Estoque</p>
    </div>

    <!-- Loading -->
    @if (isLoading) {
    <div class="loading-section flex flex-col items-center justify-center py-6">
      <app-spinner [size]="40" color="primary"></app-spinner>
      <p class="mt-4 text-gray-700">Verificando autenticação...</p>
    </div>
    }

    <!-- Login -->
    @if (!isLoading) {
    <div class="login-section text-center py-4">
      <p class="mb-6 text-gray-700">
        Você será redirecionado para fazer login no Keycloak.
      </p>

      <!-- Botão manual para login -->
      <button
        class="keycloak-login-btn inline-flex items-center px-6 py-3 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
        (click)="loginWithKeycloak()"
      >
        <app-icon name="login" color="gray" [size]="20" class="mr-2"></app-icon>
        Fazer Login
      </button>
    </div>
    }

    <!-- Links -->
    <div class="login-links mt-6 text-center">
      <a
        routerLink="/home"
        class="back-link inline-flex items-center text-primary-600 hover:text-primary-800"
      >
        <app-icon
          name="arrow_back"
          color="primary"
          [size]="16"
          class="mr-1"
        ></app-icon>
        <span>Voltar ao início</span>
      </a>
    </div>
  </div>
</div>
